import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4a8c8860&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=4a8c8860&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c8860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8c8860')) {
      api.createRecord('4a8c8860', component.options)
    } else {
      api.reload('4a8c8860', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4a8c8860&scoped=true", function () {
      api.rerender('4a8c8860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/detail.vue"
export default component.exports